import {AccountBalanceWallet, Fingerprint, Terminal} from "@mui/icons-material";
import {IconButton, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {animated} from "react-spring";
import {styled as msc} from "@mui/system";
import {Rnd} from "react-rnd";
import AboutMe from "../Sections/AboutMe";
import Shell from "../FakeTerminal/Shell";
import {mailtoHref, SITE} from "site";

import SplitRockLogo from "assets/splitrock_white.png";
import DiffExLogo from "../../assets/diffex_logo_not.png";
import GithubLogo from "assets/github.png";
import LinkedinLogo from "assets/linkedin.png";
import Team95 from "assets/robot.png";

interface IApp {
    id: string;
    key?: string;
    x: number;
    y: number;
    width: number;
    height: number;
    url?: string;
}

export default function Desktop() {
    const [openApps, setOpenApps] = useState<Array<IApp>>([]);
    const [openAppsHidden, setOpenAppsHidden] = useState<Array<string>>([]);

    useEffect(() => {
        if (openAppsHidden.length === 0) return;

        // All of openApps are in openAppsHidden so we can reset openApps... //
        if (openAppsHidden.length === openApps.length) {
            setOpenApps([]);
            setOpenAppsHidden([]);
        }

        // eslint-disable-next-line
    }, [openAppsHidden]);

    return (
        <DesktopContainer>
            <DesktopSection>
                <DesktopSectionTitle>
                    About Me
                </DesktopSectionTitle>

                <DesktopSectionContent>
                    <DesktopApp
                        onClick={() => {
                            setOpenApps([
                                ...openApps,
                                {
                                    id: "bio",
                                    key: "AboutMe",
                                    x: 0,
                                    y: 0,
                                    width: 800,
                                    height: 600,
                                },
                            ]);

                        }}
                    >
                        <Fingerprint style={{fontSize: "75px"}}/>
                        <Typography>
                            Bio
                        </Typography>
                    </DesktopApp>

                    <DesktopApp
                        onClick={() => {
                            setOpenApps([
                                ...openApps,
                                {
                                    id: "splitrock",
                                    key: "Splitrock",
                                    x: 0,
                                    y: 0,
                                    width: 800,
                                    height: 600,
                                },
                            ]);
                        }}
                    >
                        <div style={{flex: 1, display: 'flex', justifyContent: "center", alignItems: "center"}}>
                            <img alt={"Splitrock logo"} src={SplitRockLogo} width={"65px"}/>
                        </div>
                        <Typography>Splitrock</Typography>
                    </DesktopApp>

                </DesktopSectionContent>
            </DesktopSection>

            <DesktopSection>
                <DesktopSectionTitle>
                    Projects & Socials
                </DesktopSectionTitle>

                <DesktopSectionContent>
                    <DesktopApp
                        onClick={() => {
                            setOpenApps([
                                ...openApps,
                                {
                                    id: "diffex",
                                    url: "https://diffex.splitrock.dev",
                                    x: 0,
                                    y: 0,
                                    width: 1200,
                                    height: 1000,
                                },
                            ]);

                        }}
                    >
                        <img alt={"DiffEx Logo"} src={DiffExLogo} width={"75px"}/>
                        <Typography>DiffEx</Typography>
                    </DesktopApp>

                    <DesktopAppLink href={SITE.github}
                                    style={{textDecoration: "none", color: "white"}} target="_blank"
                                    rel="noopener noreferrer">
                        <div style={{flex: 1, display: 'flex', justifyContent: "center", alignItems: "center"}}>
                            <img alt={"Github Logo"} src={GithubLogo} width={"65px"}/>
                        </div>
                        <Typography>Github</Typography>
                    </DesktopAppLink>

                    <DesktopApp
                        onClick={() => {
                            setOpenApps([
                                ...openApps,
                                {
                                    id: "my-ledger",
                                    key: "MyLedger",
                                    x: 0,
                                    y: 0,
                                    width: 800,
                                    height: 600,
                                },
                            ]);
                        }}
                    >
                        <AccountBalanceWallet style={{fontSize: "75px"}}/>
                        <Typography>My Ledger</Typography>
                    </DesktopApp>

                    <DesktopAppLink href={SITE.linkedin}
                                    style={{textDecoration: "none", color: "white"}} target="_blank"
                                    rel="noopener noreferrer">
                        <div style={{flex: 1, display: 'flex', justifyContent: "center", alignItems: "center"}}>
                            <img alt={"LinkedIn Logo"} src={LinkedinLogo} width={"65px"}/>
                        </div>
                        <Typography>LinkedIn</Typography>
                    </DesktopAppLink>

                    <DesktopAppLink href={SITE.firstGithub}
                                    style={{textDecoration: "none", color: "white"}} target="_blank"
                                    rel="noopener noreferrer">
                        <div style={{flex: 1, display: 'flex', justifyContent: "center", alignItems: "center"}}>
                            <img alt={"Team95 Logo"} src={Team95} width={"65px"}/>
                        </div>
                        <Typography>Team 95</Typography>
                    </DesktopAppLink>
                </DesktopSectionContent>
            </DesktopSection>

            <DesktopSection>
                <DesktopSectionTitle>
                    Apps
                </DesktopSectionTitle>

                <DesktopSectionContent>
                    <DesktopApp
                        onClick={() => {
                            setOpenApps([
                                ...openApps,
                                {
                                    id: "shell",
                                    key: "shell",
                                    x: 0,
                                    y: 0,
                                    width: 800,
                                    height: 600,
                                },
                            ]);
                        }}
                    >
                        <Terminal style={{fontSize: "75px"}}/>
                        <Typography>Terminal</Typography>
                    </DesktopApp>
                </DesktopSectionContent>
            </DesktopSection>

            {openApps.length > 0 && (
                <>
                    {openApps.map((app, index) => (
                        <Rnd
                            key={`${app.id}-${index}`}
                            onResizeStop={(e, direction, ref, delta, position) => {
                                setOpenApps(
                                    openApps.map((app, i) =>
                                        i === index
                                            ? {
                                                ...app,
                                                width: ref.offsetWidth,
                                                height: ref.offsetHeight,
                                            }
                                            : app
                                    )
                                );
                            }}
                            onDragStop={(e, d) => {
                                setOpenApps(
                                    openApps.map((app, i) =>
                                        i === index
                                            ? {...app, x: d.x, y: d.y}
                                            : app
                                    )
                                );
                            }}
                            position={{x: app.x, y: app.y}}
                            enableResizing={app.key !== "shell"}
                            size={{width: app.width, height: app.height}}
                            style={{
                                zIndex: 100,
                                display: openAppsHidden.includes(app.id) ? "none" : ""
                            }}
                        >
                            <div style={{
                                padding: "3px",
                                background: "lightgrey",
                                display: "flex",
                                justifyContent: "flex-start",
                                borderRadius: "6px 6px 0 0"
                            }}>
                                <CloseWindow onClick={() => {
                                    setOpenAppsHidden([...openAppsHidden, app.id]);
                                }}>
                                </CloseWindow>
                            </div>

                            {app.url && (
                                <iframe
                                    style={{height: "100%", width: "100%", border: "none"}}
                                    src={app.url}
                                    title={"App Window"}
                                />
                            )}

                            {app.key === "AboutMe" && (
                                <div style={{
                                    background: "#2a2a2a",
                                    padding: "25px",
                                }}>
                                    <AboutMe/>
                                </div>
                            )}

                            {app.key === "Splitrock" && (
                                <div style={{
                                    background: "#2a2a2a",
                                    padding: "25px",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "15px",
                                }}>
                                    <Typography>
                                        <b>Splitrock Consulting</b>
                                    </Typography>
                                    <Typography>
                                        Duration: 2023 - present
                                    </Typography>
                                    <Typography>
                                        Position: Founder
                                    </Typography>
                                    <Typography>
                                        Agentic software solutions, iOS mobile development, and custom
                                        full-stack systems.
                                    </Typography>
                                    <Typography>
                                        <a href={mailtoHref}>{SITE.email}</a>
                                        {" · "}
                                        <a href={SITE.phoneHref}>{SITE.phoneDisplay}</a>
                                    </Typography>
                                </div>
                            )}

                            {app.key === "MyLedger" && (
                                <div style={{
                                    background: "#2a2a2a",
                                    padding: "25px",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "15px",
                                }}>
                                    <Typography>
                                        <b>My Ledger</b>
                                    </Typography>
                                    <Typography>
                                        Offline, local-first budgeting tool in Swift and SwiftUI.
                                    </Typography>
                                    <Typography>
                                        Source is not public. It ships with the same draft-PR,
                                        review, and tagged-release process as this site.
                                    </Typography>
                                </div>
                            )}

                            {app.key === "shell" && (
                                <Shell
                                    openApps={openApps}
                                    setOpenApps={setOpenApps}
                                />
                            )}
                        </Rnd>
                    ))}
                </>
            )}
        </DesktopContainer>
    )
}

const CloseWindow = styled(IconButton)`
  background: #fc5b57 !important;
  display: inline-block;
  width: 13px;
  height: 13px;
  margin: 0 3px;
  border-radius: 50%;
`;


const DesktopContainer = styled(animated.div)`
  padding: 125px 25px 125px 25px;
  height: calc(100vh - 88px);
  //width: 100vw;

  display: flex;
  flex-wrap: wrap;
  gap: 25px;
`;

const DesktopSection = styled.div`
  overflow: auto;
  
  flex: 1;
  min-width: 40vw;
  height: 50%;

  display: flex;
  flex-direction: column;

  padding: 25px 25px 25px 25px;

  border: 1px dashed rgb(61, 61, 61);
`;

const DesktopSectionContent = styled.div`
  flex: 1;

  padding: 15px 0;

  display: flex;
  flex-wrap: wrap;
  gap: 25px;
`;

const DesktopSectionTitle = msc(Typography)`
    font-size: 20px;
    flex: 0;
    margin: 10px;
`;

const DesktopApp = styled.div`
  cursor: pointer;
  min-width: 75px;
  max-width: 90px;
  height: 100px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const DesktopAppLink = styled.a`
  cursor: pointer;
  min-width: 75px;
  max-width: 90px;
  height: 100px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
